import React from 'react';
import { Link } from 'react-router-dom';

import './app-card.scss';

export interface AppCardProps {
  image: string;
  logo?: string;
  icon?: string;
  text?: string;
  description?: string;
  linkTo: string;
  blank?: boolean;
}

export const AppCard: React.FC<AppCardProps> = ({ image, icon, text, description, linkTo, blank }) => {
  const CommingSoon = () => (
    <div className="info">
        <div className="info__name info__name--coming-soon">
          <div className="info__name__text">Coming soon!</div>
        </div>
      </div>
  );

  return (
    <Link to={linkTo} className="apps__app">
      <img src={image} alt={text} className="apps__app__image"/>
      {
        !blank ? (
          <div className="info">
            <div className="info__name">
              <img src={icon} alt={`${text} logo`} className="info__name__image"/>
              <div className="info__name__text">
                {text}
              </div>
            </div>
            <p className="description">
              {description}
            </p>
          </div>
        ) : <CommingSoon />
      }
    </Link>
  );
};
